import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/simpleRacer.css';
// components
import Racer from '../components/racer';
// constants
import {PLACE, SHOW, WIN} from '../../../../modules/racing/constants/identifiers';
import {incrementBetValue} from '../../../../actions/openBetsActions';
import {
    compareBetRacers,
    createBet,
    getOpenBet,
    getRacingSingleMarket,
    marketHasOpenBet
} from '../../../../helpers/betHelpers';
import {getChipValue, getClosestChipByValue} from '../../../../../../constants/chips';
import {getFormattedCurrency} from '../../../../../../helpers/localization';
import {ASSETS_URL} from '../../../../../../constants/endpoints';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip,
        openBetsHistory: state.vpp.openBetsHistory
    };
};

class SimpleRacer extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory
        });
    }

    _createBetChipsUI(selectedGame, selectedEvent, market, racers) {
        let betChipsUI = [];
        let totalStake;
        if (this.state.openBetsHistory && this.state.openBetsHistory.length) {
            let currBetHistory = this.state.openBetsHistory.filter((bet) => bet.game.channel === selectedGame.channel && bet.event.eventId === selectedEvent.eventId && bet.market.code === market.code && compareBetRacers(bet.racers, racers));

            if (currBetHistory && currBetHistory.length) {
                if (currBetHistory.length === 1) {
                    totalStake = currBetHistory[0].value;
                } else {
                    totalStake = currBetHistory.reduce((acc, betHist) => +acc + betHist.value, 0);
                }
            } else {
                return '';
            }

            betChipsUI = (<div id={'betChips_' + market.id} className={style.betChipsContainer}>
                <img key={'CHIP_STAKE'} className={style.betChips}
                     src={`${ASSETS_URL + getClosestChipByValue(totalStake).assetChip}`} alt={'chips'}/>
                <div className={style.chipValueOuter}>
                    <div
                        className={style.chipValueInner}>{getFormattedCurrency(this.props.store, totalStake / 100, 0)}</div>
                </div>
            </div>);
        }
        return betChipsUI;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedChip = this.state.selectedChip;
        let incrementValue = getChipValue(selectedChip);
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let oddsText;
        let market;
        let isSelected;
        switch (storeData.vpp.selectedRacingBetType) {
            case WIN:
                market = getRacingSingleMarket(WIN.code, this.props.racer.num, storeData.vpp.events[storeData.vpp.selectedEventIndex].markets);
                if (market) {
                    isSelected = marketHasOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList);
                    if (isSelected) {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsFirst * getOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList).stake / 100).toFixed(2));
                    } else {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsFirst * incrementValue / 100).toFixed(2));
                    }
                }
                break;
            case PLACE:
                market = getRacingSingleMarket(PLACE.code, this.props.racer.num, storeData.vpp.events[storeData.vpp.selectedEventIndex].markets);
                if (market) {
                    isSelected = marketHasOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList);
                    if (isSelected) {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsPlace * getOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList).stake / 100).toFixed(2));
                    } else {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsPlace * incrementValue / 100).toFixed(2));
                    }
                }
                break;
            case SHOW:
                market = getRacingSingleMarket(SHOW.code, this.props.racer.num, storeData.vpp.events[storeData.vpp.selectedEventIndex].markets);
                if (market) {
                    isSelected = marketHasOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList);
                    if (isSelected) {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsShow * getOpenBet(selectedGame, selectedEvent, market, [this.props.racer], this.state.openBetsList).stake / 100).toFixed(2));
                    } else {
                        oddsText = getFormattedCurrency(this.props.store, (this.props.racer.oddsShow * incrementValue / 100).toFixed(2));
                    }
                }
                break;
            default:
                break;
        }


        if (market === undefined) {
            return (<div></div>);
        }

        let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, market, [this.props.racer]);

        return (<div className={style.simpleRacer}>
            <div className={`${style.button} ${isSelected
                ? style.selected
                : ''}`}
                 onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, market, [this.props.racer], incrementValue), incrementValue, storeData.vpp.openBetsList))}>
                <Racer racer={this.props.racer} isSelected={false} isSimpleRacer={true} oddsText={oddsText}
                       store={this.props.store}/> {betChipsUI}
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(SimpleRacer);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/components/simpleRacer.js